import React, { useRef, useState } from 'react';
import ActivityLoader from '../Common/ActivityLoader';
import BsModal from '../Common/BsModal';
import ReportFormat from '../Report/ReportFormat'; // ✅ Reused component
import printContent from '../../util/araknerdlib';

const AlertReportViewer = ({ show, onClose, report, reportInfo }) => {
  const [loading, setLoading] = useState(false);
  const reportRef = useRef();

  const student = report?.data?.[0];


 const handlePrint = () => printContent(reportRef, `${student?.student_info?.full_name} Report`, false);


  return (
    <BsModal
      show={show}
      size="modal-xl"
      onClose={onClose}
      title="Report Viewer"
      maxHeight='75vh'
      footer={
        <>
          {loading ? (
            <ActivityLoader />
          ) : (
            <>
              <button className="btn btn-secondary" onClick={onClose}>Close</button>
              <button className="btn btn-primary" onClick={handlePrint} disabled={!student}>Print</button>
            </>
          )}
        </>
      }
    >
    <div ref={reportRef} className="report-viewer">
      {student ? (
        <ReportFormat
          key={student.student_id}
          student={student}
          studentId={student.student_id}
          reportInfo={reportInfo}
          initials={report?.initials}
          totalStudents={report?.meta?.total}
          final={true}
        />
      ) : (
        <ActivityLoader />
      )}
    </div>
    </BsModal>
  );
};

export default AlertReportViewer;
